<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <h4 class="color-secundary">Resumen de cifras con corte a: {{fechaCorte}}</h4>
      <br />

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        @click-event="clickEvent"
        :dataLength="dataLength"
        pagination
        :perPage="10000"
        showExportToExcel
      >
        <table-column
          slot="label"
          :label="'Código'"
          showExportToExcel
          v-bind:value="'convenio'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'alias'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Total Desembolsos'"
          v-bind:value="'movilizado'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor generado para reclamación'"
          v-bind:value="'siniestralidad_real'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cartera'"
          v-bind:value="'cartera'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Saldo total'"
          v-bind:value="'saldo_total'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Total Pagado'"
          v-bind:value="'pagado'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Otros pagos'"
          v-bind:value="'otros_real'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Saldo para reclamación'"
          v-bind:value="'disponible_real'"
          :filter="'numberFormat'"
          :customClass="'text-right'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      fechaCorte: "",
      data: [],
      dataLength: 0
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn")
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading"
    }),
    rows() {
      return this.TablaEstadoProceso.length;
    },
    routeName() {
      return this.$router.currentRoute.name;
    }
  },
  methods: {
    clickEvent(event, slug) {
      this.$store.commit("SET_LOADING", true);
      switch (slug) {
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000
          });
          try {
            let info_to_export = Array();

            this.data.forEach(element => {
              info_to_export.push({
                convenio: element.convenio,
                modelo: element.modelo,
                alias: element.alias,
                movilizado: element.movilizado,
                siniestralidad_real: element.siniestralidad_real,
                cartera: element.cartera,
                saldo_total: element.saldo_total,
                pagado: element.pagado,
                otros_real: element.otros_real,
                disponible_real: element.disponible_real
              });
            });

            let data = XLSX.utils.json_to_sheet(info_to_export, {
              header: [
                "convenio",
                "modelo",
                "alias",
                "movilizado",
                "siniestralidad_real",
                "cartera",
                "saldo_total",
                "pagado",
                "otros_real",
                "disponible_real"
              ]
            });
            data["A1"].v = "Código";
            data["B1"].v = "Modelo";
            data["C1"].v = "Producto";
            data["D1"].v = "Valor crédito";
            data["E1"].v = "Valor generado para reclamación";
            data["F1"].v = "Cartera";
            data["G1"].v = "Saldo total";
            data["H1"].v = "Total Pagado";
            data["I1"].v = "Otros agos";
            data["J1"].v = "Saldo para Reclamación";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, "Resumen Cifras");
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "ResumenCifras.xlsx"
            );
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000
              }
            );
          }
          break;
      }
      this.$store.commit("SET_LOADING", false);
    },
    async dataProcesada() {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get(
          "portal/informes/resumen_cifras",
          { params: { paginar: false } }
        );
        let dataProcesada = [];

        let data = response.data.datos.filter(
          e =>
            e.disponible_real != 0 ||
            e.movilizado != 0 ||
            e.otros_real != 0 ||
            e.pagado != 0 ||
            e.siniestralidad_real != 0 ||
            e.cartera != 0
        );

        let convenios = [];

        data.forEach(e => {
          if (convenios.indexOf(e.convenio) == -1) {
            convenios[e.convenio] = e.convenio;
          }
        });


        convenios.forEach(element => {
          let infoConvenios = data.filter(e => e.convenio == element);

          infoConvenios.forEach(e => {
            e.alias = e.producto;
          });

          let totales_convenios = {
            alias: "Total por convenio:",
            disponible_real: infoConvenios.reduce(
              (a, b) => parseInt(a) + b.disponible_real,
              0
            ),
            movilizado: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.movilizado),
              0
            ),
            pagado: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.pagado),
              0
            ),
            otros_real: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.otros_real),
              0
            ),
            siniestralidad_real: infoConvenios.reduce(
              (a, b) => parseInt(a) + b.siniestralidad_real,
              0
            ),
            cartera: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.cartera),
              0
            ),
            saldo_total: infoConvenios.reduce(
              (a, b) => parseInt(a) + parseInt(b.saldo_total),
              0
            ),
            primary: true
          };

          dataProcesada = dataProcesada.concat(infoConvenios);
          dataProcesada.push(totales_convenios);
        });


        this.data = dataProcesada;
        this.dataLength = dataProcesada.length;
        this.$store.commit("SET_LOADING", false);
        return true;
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar consultar los datos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000
          }
        );
        this.$store.commit("SET_LOADING", false);
        return false;
      }
    }
  },
  mounted() {
    this.dataProcesada();
    this.fechaCorte = this.$moment().format("YYYY-MM-DD");
  }
};
</script>